import { Component } from "@angular/core";

@Component({
	selector: "customer-segmentation-intro",
	templateUrl: "./customer-segmentation-intro.component.html",
	styleUrls: ["../../customer-segmentation.component.scss", "../../../../../../theme/shared/shared-modal.scss"],
	standalone: false
})
export class CustomerSegmentationIntroComponent {
	public prefix: string = "uk_customer_segmentation_appropriateness_test";
	public data = {
		title: this.prefix + ".intro_title",
		items: [
			{
				src: "/assets/images/customer-segmentation-intro-safety.svg",
				alt: "safe",
				title: this.prefix + ".intro_item_1_title",
				description: this.prefix + ".intro_item_1_description"
			},
			{
				src: "/assets/images/customer-segmentation-intro-compliance.svg",
				alt: "compliance",
				title: this.prefix + ".intro_item_2_title",
				description: this.prefix + ".intro_item_2_description"
			}
		]
	};
}
